// extracted by mini-css-extract-plugin
export default {"container":"EmailShare_container__I1pVn","shareEmailBtn":"EmailShare_shareEmailBtn__bMW17","emailSvg":"EmailShare_emailSvg__ldnIr"};